/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getUserCoverTable = params => {
  return axios.post(`${base}/usercover_search`, params)
}



// WEBPACK FOOTER //
// ./src/views/user-cover/user-cover.api.js